import { Router, ActivatedRoute } from '@angular/router';
import { Injectable, inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class QueryParamsService {
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  constructor() {}

  setQueryParamsEncoded(key: string, value: any[] | any): void {
    this.router.navigate([], {
      queryParamsHandling: 'merge',
      replaceUrl: true,
      queryParams: {
        // [key]: value || (value && value.length > 0) ? this.encode(value) : null,
        [key]: value && value?.length > 0 ? this.encode(value) : null,
      },
    });
  }

  getQueryParamsDecoded(key: string): any | any[] {
    const param = this.route.snapshot.queryParamMap.get(key);
    if (!param) {
      return [];
    }

    const decoded = this.decode(param);
    return decoded != null ? decoded : [];
  }

  setQueryParams(key: string, value: any[] | any): void {
    this.router.navigate([], {
      queryParamsHandling: 'merge',
      replaceUrl: true,
      queryParams: {
        [key]: value,
      },
    });
  }

  getQueryParams(key: string): any | any[] {
    let param = this.route.snapshot.queryParamMap.get(key);
    if (param) {
      return JSON.parse(param);
    }

    return [];
  }

  deleteQueryParams(): void {
    this.router.navigate([], { replaceUrl: true });
  }

  private resetQueryParams(): void {
    this.router.navigate([], { replaceUrl: true });
  }

  private encode(value: any | any[]): string {
    return btoa(JSON.stringify(value));
  }

  private decode(value: any | any[]) {
    let val = value.replace('%3D', '');
    try {
      return JSON.parse(atob(val));
    } catch (err) {
      this.resetQueryParams();
      val = null;
    }
  }
}
